import type { FaireProductEntity } from "../../entity_types/product";

export const p_84x66qe9z6: FaireProductEntity = {
  token: "p_84x66qe9z6",
  type: "product",
  name: "BESTSELLER EXPRESSO - SPRING '26 Floral Sneakers SHIPS FAST✈",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl:
    "https://cdn.faire.com/fastly/80dfb2e9a4b308d70adf75e6994d122f947dddfc238bcf8879e0334188e73584.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e03b72f2e4f0a6aa6e0a7b721ec2f93c844c6aedcbfa43c41d46eaedb1dfd759.jpeg",
    "https://cdn.faire.com/fastly/a3e04aecfc7f1b964ebc4cc6b87dcedcaeae94c9d2509399f86b5a5a2a52678c.jpeg",
    "https://cdn.faire.com/fastly/da12cce839bacbef457b1c72f37747869e592ead03fa1b9e48b082b4e7029b00.jpeg",
    "https://cdn.faire.com/fastly/d556ddb040fb7393332e7c6b03e500f52c34129db85ad0363d0c1f5487f13f9c.jpeg",
    "https://cdn.faire.com/fastly/10e5792cafa557bdba8bf9cbfd422324b030aeefd6af7647182aa484bbc965c0.jpeg",
    "https://cdn.faire.com/fastly/ec1a7ef1dd75913dbd7039a7f77e25cd97d95615a4ef384cc95554e1d8d7e0ce.jpeg",
    "https://cdn.faire.com/fastly/2d63bfa8fbc70c7bc11c28807794b0b8cb0b895b388b578dfbce611821e93bcf.jpeg",
    "https://cdn.faire.com/fastly/9281fa4d3fb47a3086ff00c4ba0c44c6b36b40f81cd5b3824abc22e3ed0dbbe1.jpeg",
    "https://cdn.faire.com/fastly/d880cfd15353824d5f5723d043da7493c5ea3afeda729ff137bc90923026e115.jpeg",
    "https://cdn.faire.com/fastly/280a24534c81dbb803d03939ee1b158dbf19b33405c618d2653384ed38063911.jpeg",
    "https://cdn.faire.com/fastly/32f2e91757a56d925d511b0807ed395d67bc73aed2a4e3a3b0aa3a8ed7c4534b.jpeg",
    "https://cdn.faire.com/fastly/86df24facc3822eb46277ccdc13a76294d2bdba0d3e28fef9c398608d6d4963f.jpeg",
    "https://cdn.faire.com/fastly/55fe46eafd9f2b557226e2401aef271d2e7bf755c8ac02207e5594e6cb7435a8.jpeg",
    "https://cdn.faire.com/fastly/c59a94542b897427b4bb7190e57ebc1f6b9406e837c68ffa783396a01d785114.jpeg",
    "https://cdn.faire.com/fastly/08d3704b6d2751ef7877ff95b319bbd756ec4269d51f6e6e209a6fb262f96206.jpeg",
    "https://cdn.faire.com/fastly/477314a868edf51747924aa0af9bf5e0d56e4fda47f79c249bcf64d6516c7247.jpeg",
    "https://cdn.faire.com/fastly/840e4276b9b0b091e5ebc90235c6d2c0720623110d1846343e54bac640a389cf.jpeg",
    "https://cdn.faire.com/fastly/4cfc4dde2cadbe6ae1104d7fa0498c29710686d356b59b1c29e7395deac4cec7.jpeg",
    "https://cdn.faire.com/fastly/7148768bba3314a590ac83839a3b57afdd83d909af1671ffc1f1c23c5797de47.jpeg",
    "https://cdn.faire.com/fastly/142d21eee37cfba2e868c36468d4e191c0f44ca55da4eef40815cfafe1139e37.jpeg",
    "https://cdn.faire.com/fastly/9f5b0dbfcef2fdbfbf97c838ffe1d7af3bcde25d76e94333447923097c5d5aa6.jpeg",
    "https://cdn.faire.com/fastly/9e878f2b81fd483393d993d26398e1252f62c5ca91aaa4586e43453334234b42.jpeg",
    "https://cdn.faire.com/fastly/41795d7fc2b9e80ed9eee780d2a6cb7f2335c38952b6b5d39a33ebebeac03b36.jpeg",
  ],
  priceDollars: 15,
  description:
    "*2025 In-stock Favorite 🏆*\n\nEXPRESSO is a sweet take on your everyday go-to. Featuring a soft pastel floral print with contrast striping and a classic gum sole, these sneakers blend sporty comfort with feminine charm. Perfect for everyday wear with a playful twist.\n\n𝐎𝐎𝐓𝐃:\nFor a casual weekend look, style them with high-waisted denim shorts, a white baby tee, and a pink crossbody bag. Add a scrunchie and some gold hoops to keep it cute and comfy.\n\nFor a laid-back brunch fit, pair with a flowy midi skirt and a cropped cardigan. Finish with dainty layered necklaces and oversized sunnies for an effortlessly pretty vibe.\n\n• Floral Sneaker\n• Contrast Striping\n• Lace Up\n• Colors: Lavender, Blue, Pink, White",
  tags: [],
  msrpDollars: 40,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:49:19.733Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
